// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#scroll-to-top{font-size:1.4rem;color:#fff;background:#7dc260;position:fixed;bottom:2rem;right:2rem;border-radius:100%;padding:0 .55rem;z-index:99999999!important;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);height:3rem;width:3rem;cursor:pointer;text-align:center;line-height:2.5rem}@media screen and (max-width:767px){#scroll-to-top{bottom:90px;right:25px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
